import { createAccessControl } from "better-auth/plugins/access";
import { adminAc, defaultStatements } from "better-auth/plugins/admin/access";

export type { Role } from "@/db/schema";

export const statement = {
  tournaments: ["create", "update", "delete"],
  venues: ["create", "update", "delete"],
  content: ["update"],
  files: ["create", "delete"],
  profiles: ["create", "update"],
  faqs: ["create", "update", "delete"],
  blogs: ["create", "update", "delete"],
  helpArticles: ["create", "update", "delete"],
  articles: ["update"],
  invoices: ["read", "update"],
  settings: ["read", "create", "update"],
  memberships: ["create", "revoke"],
  ...defaultStatements,
} as const;

export const ac = createAccessControl(statement);

export type Permissions = {
  [K in keyof typeof statement]?: Array<(typeof statement)[K][number]>;
};

export const admin = ac.newRole({
  tournaments: ["create", "update", "delete"],
  venues: ["create", "update", "delete"],
  content: ["update"],
  files: ["create", "delete"],
  profiles: ["create", "update"],
  faqs: ["create", "update", "delete"],
  blogs: ["create", "update", "delete"],
  helpArticles: ["create", "update", "delete"],
  articles: ["update"],
  invoices: ["read", "update"],
  settings: ["read", "update"],
  memberships: ["create", "revoke"],
  ...adminAc.statements,
});

export const superadmin = ac.newRole({
  ...admin.statements,
  settings: ["read", "create", "update"],
});

export const td = ac.newRole({
  tournaments: ["update"],
  venues: ["update"],
  files: ["create", "delete"],
  profiles: ["create", "update"],
});

export const user = ac.newRole({
  tournaments: [],
  files: ["create", "delete"],
  profiles: ["create", "update"],
});
